import {
    initSwiper,
    renderCSS,
    renderElements, renderForm, renderFormPreview,
} from './widereview/widereview';

(function () {
    const container = document.getElementById('widereview');

    if (!container) return;

    const options = window.app_widereview_data && window.app_widereview_data.options
        ? window.app_widereview_data.options
        : null;

    const reviews = window.app_widereview_data && window.app_widereview_data.reviews
        ? window.app_widereview_data.reviews
        : null;

    if (!options || !reviews) return;

    renderCSS(options);
    renderElements(container, reviews, options);

    initSwiper();
})();

(function () {
    const installForm = document.getElementById('installForm');

    if (installForm) {
        installForm.addEventListener('submit', function (event) {
            event.preventDefault();

            let form = this,
                url = this.getAttribute("action");

            for (let i = 0; i < form.elements.length; i++) {
                const element = form.elements[i];

                if (element.name === 'shop') {
                    url += (url.indexOf('?') === -1 ? '?' : '&') + 'shop=' + element.value;
                }
            }

            window.location.href = url;
        });
    }
})();
